import { CockpitPeriodKey } from '../model/types'

import { getCockpitPeriodQuarters } from './getCockpitPeriodQuarters'

/** The selected quarters behind each half of the expected exit, ascending. */
export interface IExpectedExitQuarters {
  /** Closed quarters — read as actuals. */
  actuals: number[]
  /** The quarter in progress and any quarters ahead — read as plan. */
  plan: number[]
}

/** Which of the selected quarters the expected exit reads as actuals and which as plan — the same
 *  split `getExpectedExitRows` makes on the rows themselves (`currentFQuarter` itself counts as not
 *  yet closed), stated for the period as a whole so every row of the table lists the same quarters.
 *  A past year (`currentFQuarter` `5`) is all actuals; a future one (`0`) is all plan. */
export const getExpectedExitQuarters = (
  periods: CockpitPeriodKey[],
  currentFQuarter: number
): IExpectedExitQuarters => {
  const quarters = getCockpitPeriodQuarters(periods, currentFQuarter)

  return {
    actuals: quarters.filter((quarter) => quarter < currentFQuarter),
    plan: quarters.filter((quarter) => quarter >= currentFQuarter),
  }
}
